export const REQUIRED_ICC_ERROR = 'El ICC es obligatorio'
export const INVALID_ICC = 'El ICC no es válido'
export const OPERATOR_NOT_FOUND = 'El numero a portar no pertenece a ningún operador'
export const OPERATOR_FAILED = 'Ha habido un fallo en la comprobación del número a portar'
export const PHONE_INVALID = 'El teléfono introducido es inválido'
export const TRY_AGAIN = 'Probar de nuevo'
export const CONTINUE = 'Continuar'
export const NEW_NUMBER_FAILED = 'Ha habido un problema al crear el nuevo número'
export const SAME_ICC = 'El ICC de la tarjeta donante no puede ser igual que el ICC en tienda'
